import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import GameInterface from './index';
import store from '../../state/store';
import { setNewAgsiBet, setFeatureModeEnabled } from '../../state/actions/agsi';
import { setSpinEvent } from '../../state/slices/spinEvent/spinEvent';
import SPIN_PHASE from './helpers/spinPhases';
var Agsi = /*#__PURE__*/function (_GameInterface) {
  /**
   * GameInterface constructor
   * @param {Object} args
   * @param {import("../Constants").BetInfo} args.BetInfo
   * @param {Function} args.ExitFunc
   */
  function Agsi(args) {
    var _this;
    _classCallCheck(this, Agsi);
    _this = _callSuper(this, Agsi, [args]);
    /**
     * Agsi Event Handler
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */
    _this.kvpParserEvent = function (event) {};
    /**
     * Check FTUE Event Handler
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */
    _this.jsonParserEvent = function (event) {
      var playerId = store.getState().playerInfo.playerId;
      var gameId = store.getState().gameInfo.gameId;
      var _store$getState$lastS = store.getState().lastSpinEvents.balanceAfter,
        balance = _store$getState$lastS === void 0 ? null : _store$getState$lastS;
      var featureModeEnabled = store.getState().agsi.featureModeEnabled;
      switch (event.action) {
        case 'stakeUpdate':
          store.dispatch(setNewAgsiBet(event.data.stake));
          break;
        case 'gameRoundStarted':
          /* 
            Agsi does not offer a specific event for free spins 
            so we use the 'featureModeEnabled' flag to know if the player is 
            inside free spins/jackpots/bonuses or real spins 
          */
          if (!featureModeEnabled) {
            _this.currentBet = store.getState().agsi.betValue;
            store.dispatch(setSpinEvent({
              playerId: playerId,
              createdTimestamp: Date.now(),
              spinPhase: SPIN_PHASE.WAGE,
              amount: _this.currentBet,
              gameId: gameId
            }));
          }
          break;
        case 'insufficientFunds':
          _this._outOfCoins();
          _this.showOutOfCoinsScreen();
          break;
        case 'enableFeatureMode':
          store.dispatch(setFeatureModeEnabled(true));
          break;
        case 'disableFeatureMode':
          store.dispatch(setFeatureModeEnabled(false));
          break;
        case 'winningsUpdate':
          if (event.data.winnings > 0 && !featureModeEnabled) store.dispatch(setSpinEvent({
            playerId: playerId,
            createdTimestamp: Date.now(),
            spinPhase: SPIN_PHASE.WIN,
            gameId: gameId,
            amount: event.data.winnings
          }));
          break;
        case 'gameRoundEnded':
          if (!featureModeEnabled) {
            _this.AddSpinXP(_this.currentBet);
          }
          break;
        case 'balancesUpdate':
          if (!featureModeEnabled) {
            _this.syncCoinsBalance(event.data.balances.cash);
            store.dispatch(setSpinEvent({
              balanceBefore: balance ? balance : event.data.balances.cash,
              balanceAfter: event.data.balances.cash
            }));
          }
          break;
      }
    };
    _this.currentBet = 0;
    return _this;
  }
  _inherits(Agsi, _GameInterface);
  return _createClass(Agsi);
}(GameInterface);
export default Agsi;